import request from '@/middleware/request'

const login = data => {
  return request({
    url: '/auth/token',
    method: 'post',
    data
  })
}

const loginGoogle = data => {
  return request({
    url: '/auth/google',
    method: 'post',
    data
  })
}

const loginAzure = data => {
  return request({
    url: '/auth/azure',
    method: 'post',
    data
  })
}

const getLocalParams = () => {
  return request({
    url: '/auth/local/params',
    method: 'get'
  })
}

const getGoogleParams = () => {
  return request({
    url: '/auth/google/params',
    method: 'get'
  })
}

const getAzureParams = () => {
  return request({
    url: '/auth/azure/params',
    method: 'get'
  })
}

const getEmailFromResetToken = token => {
  return request({
    url: `/reset/password/${token}`,
    method: 'get'
  })
}

const resetPassword = data => {
  return request({
    url: '/reset/password',
    method: 'post',
    data
  })
}

const updatePassword = data => {
  return request({
    url: '/reset/password',
    method: 'patch',
    data
  })
}

const logout = () => {
  return request({
    url: '/auth/logout',
    method: 'get'
  })
}

const refreshToken = data => {
  return request({
    url: '/auth/refresh',
    method: 'post',
    data
  })
}

export default {
  login,
  loginGoogle,
  loginAzure,
  getLocalParams,
  getGoogleParams,
  getAzureParams,
  getEmailFromResetToken,
  resetPassword,
  updatePassword,
  logout,
  refreshToken
}
